/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_CustomInputs */

const en_mk_mx_custom = /** @type {(inputs: Mk_Mx_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By agreement`)
};

const id_mk_mx_custom = /** @type {(inputs: Mk_Mx_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesuai kesepakatan`)
};

/**
* | output |
* | --- |
* | "By agreement" |
*
* @param {Mk_Mx_CustomInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_custom = /** @type {((inputs?: Mk_Mx_CustomInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_CustomInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_custom(inputs)
	return en_mk_mx_custom(inputs)
});